"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
// the regexp allows to parse things like "click::x(.y)"
// it's shared between few modules
var _default = /([^::]+)::([^()]+)?(?:\((.*)\))?/;
exports["default"] = _default;
//# sourceMappingURL=_domeventregexp.js.map